/**
 * @generated SignedSource<<a193fc57bffdf124034cab4a9a99574f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Links_userProfile$data = {
  readonly externalLinks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly label: string | null;
        readonly url: string;
      };
    }>;
  };
  readonly id: string;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileExternalLink_userProfile">;
  readonly " $fragmentType": "Links_userProfile";
};
export type Links_userProfile$key = {
  readonly " $data"?: Links_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"Links_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Links_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfileExternalLinkConnection",
      "kind": "LinkedField",
      "name": "externalLinks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfileExternalLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserProfileExternalLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileExternalLink_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "611a4b0b0522479eb83561f5cd121e90";

export default node;
